import React, { useState } from 'react';
import SaudiFlagIcon from './icons/SaudiFlagIcon';
import LinkCircleIcon from './icons/LinkCircleIcon';
import LockCircleIcon from './icons/LockCircleIcon';
import { useLanguage } from '../contexts/LanguageContext';

const GovernmentVerificationBanner = () => {
  const { t, isRTL } = useLanguage();
  const [verifyOpen, setVerifyOpen] = useState(false);

  const ChevronDown = ({ className }: { className?: string }) => (
    <svg viewBox="0 0 24 24" width="16" height="16" className={className}>
      <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" />
    </svg>
  );

  return (
    <div className="bg-white border-b border-gray-200" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="max-w-full mx-auto px-4 md:px-6 py-2">
        <div className={`flex flex-wrap items-center justify-between gap-3 text-[13px] text-gray-700 ${isRTL ? '' : 'flex-row-reverse'}`}>
          <div className={`flex items-center gap-2 ${isRTL ? '' : 'flex-row-reverse'}`}>
            <SaudiFlagIcon
              size={20}
              className="text-[#006923] rounded-[3px] overflow-hidden"
              title={t('saudiFlagTitle')}
            />
            <span className="text-neutral-700 font-[600]">
              {t('officialGovWebsite')}
            </span>
            <button
              type="button"
              className={`text-sa-600 text-md font-[700] hover:text-sa-700 cursor-pointer ${isRTL ? 'ps-2' : 'pe-2'} rounded transition-colors inline-flex items-center gap-1`}
              aria-expanded={verifyOpen}
              onClick={() => setVerifyOpen((v) => !v)}
            >
              {t('howToVerify')}
              <ChevronDown className={`transition-transform ${verifyOpen ? "rotate-180" : ""}`} />
            </button>
          </div>
        </div>

        {/* VERIFY COLLAPSE */}
        <div
          className={`overflow-hidden transition-all duration-200 ${
            verifyOpen ? "max-h-[400px] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          <div className={`flex items-center flex-wrap gap-8 pt-3 mt-3 pb-2 border-t border-gray-200 ${isRTL ? '' : 'flex-row-reverse'}`}>
            {/* .gov.sa block */}
            <div className="flex-1 min-w-[260px]">
              <div className={`flex items-center gap-4 ${isRTL ? '' : 'flex-row-reverse'}`}>
                <div className="flex mt-2 items-center justify-center">
                  <LinkCircleIcon size={40} className="text-sa-700 drop-shadow-sm" />
                </div>
                <div className={`text-xl font-[700] text-neutral-800 ${isRTL ? 'text-right' : 'text-left'}`}>
                  {t('officialLinksEndWith')}{" "}
                  <strong className="text-sa-600">{t('govSa')}</strong>
                </div>
              </div>
              <div className={`text-lg text-neutral-600 ${isRTL ? 'ps-14 text-right' : 'pe-14 text-left'}`}>
                {t('officialLinksDesc')}
              </div>
            </div>

            {/* HTTPS block */}
            <div className="flex-1 min-w-[260px]">
              <div className={`flex items-center gap-4 ${isRTL ? '' : 'flex-row-reverse'}`}>
                <div className="flex mt-2 items-center justify-center">
                  <LockCircleIcon size={40} className="text-sa-700 drop-shadow-sm" />
                </div>
                <div className={`text-xl font-[700] text-neutral-800 ${isRTL ? 'text-right' : 'text-left'}`}>
                  {t('govWebsitesUseHttps')}
                </div>
              </div>
              <div className={`text-lg text-neutral-600 ${isRTL ? 'ps-14 text-right' : 'pe-14 text-left'}`}>
                {t('secureWebsitesDesc')}
              </div>
            </div>
          </div>

          {/* Digital Government Stamp */}
          <div className="pb-3">
            <div className={`hidden md:flex items-center gap-3 px-4 py-3 rounded-lg border bg-emerald-50 text-emerald-700 border-emerald-300 shadow-sm ${isRTL ? 'flex-row' : 'flex-row-reverse'}`}>
              <div className={`flex-shrink-0 ${isRTL ? 'order-1' : 'order-2'}`}>
                <img src="/images/logo-icon.svg" alt="MOIA" className="h-6 w-6 object-contain rounded-sm" />
              </div>
              <div className={`flex-1 ${isRTL ? 'order-2' : 'order-1'}`}>
                <div className={`text-md font-[700] ${isRTL ? 'text-right' : 'text-left'}`}>
                  {t('registeredWithDGA')}{" "}
                  <span style={{ textDecoration: "underline" }}>
                    <a
                      href="https://raqmi.dga.gov.sa/platforms/platforms/cd54803f-e8f4-4bb3-3773-08de46ba153b/platform-license"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      20260122317
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GovernmentVerificationBanner;

